import { render, staticRenderFns } from "./AccountStatementB2B.vue?vue&type=template&id=1d0a2d33&"
import script from "./AccountStatementB2B.vue?vue&type=script&lang=js&"
export * from "./AccountStatementB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports